import type { BrowseDataAPIProduct } from 'src/services/browse-data-api/types/BrowseDataAPIProduct';

const MAX_ITEMS_TO_SEND_TO_RR = 15;

export const getProductCodesFromPlacementItem = (items: BrowseDataAPIProduct[]) =>
  items.slice(0, MAX_ITEMS_TO_SEND_TO_RR).map(({ code }) => code);
